import React from "react";
import { ExtraOption, WarehouseExtraOption } from "../../types";

export type SelectableOption<T = unknown> = ExtraOption<T>;

export const formatOptionLabelSaleWarehouse = (option: SelectableOption<WarehouseExtraOption>): React.ReactNode => {
    const isInStock = option?.stockQuantity && option?.quantityForRender;
    return (
        <div>
            {option.label}{" "}
            {isInStock && (
                <>
                    ({option?.quantityForRender} = {option?.stockQuantity})
                </>
            )}
        </div>
    );
};
